import React from 'react'
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import Awards from '../components/Appendices/Awards';
import Certifications from '../components/Appendices/Certifications';
import Partners from '../components/Appendices/Partners';
import Download from '../components/Home/Download';
import Banner from '../components/Strategy/Banner'

const Appendices = () => {
    const { t } = useTranslation();
    const bannerData = {
        headline1: t("bannerAppendices.headLine1"),
        headline2: t("bannerAppendices.headLine2-1"),
        // description: t("bannerAppendices.description"),
        img: '/imgs/appendices/banner-img.png'
    }

    return (
        <>
            <Helmet>
                <title>{t("head.website_title")}</title>
            </Helmet>
            <Banner bannerData={bannerData} appendicesPage/>
            <Awards/>
            <Certifications/>
            {/* <Partners/> */}
            {/* <Download appendicesPage/> */}
        </>
    )
}

export default Appendices